import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  Paper,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Blog() {
  const [blogPosts, setBlogPosts] = useState([]);
  const [tableData, setTableData] = useState({});

  useEffect(() => {
    fetch("/blog.json")
      .then((res) => res.json())
      .then((data) => setBlogPosts(data))
      .catch((err) => console.error("Blog JSON fetch error:", err));
    fetch("/pesupalvelu.json")
      .then((res) => res.json())
      .then((data) => setTableData(data))
      .catch((err) => console.error("Fiyat verisi yüklenemedi:", err));
  }, []);

  return (
    <Box className="p-4" sx={{ minHeight: "100vh" }} mt="10%">
      <Helmet>
        <title>Pesupalvelut ja Kodin Siivousvinkit | Ehankki</title>
        <meta
          name="description"
          content="Tutustu edullisiin pesupalveluihin ja lue vinkit kodin siivoukseen, huonekalujen hoitoon ja sisustukseen."
        />
        <meta
          name="keywords"
          content="pesupalvelu, käytetty sohva, matto, käytetty huonekalut"
        />
        <meta property="og:title" content="Pesupalvelut ja Blogi | Ehankki" />
        <meta
          property="og:description"
          content="Ehankki tarjoaa edullisia pesupalveluja ja kodin siivousvinkkejä blogi-kategoriassaan. Lue lisää!"
        />
        <meta property="og:url" content="https://ehankki.fi/blogi" />
        <meta property="og:type" content="article" />
        <meta property="og:image" content="https://ehankki.fi/logo_son.jpg" />
        <link rel="canonical" href="https://ehankki.fi/blogi" />
      </Helmet>

      <Typography
        variant="h4"
        color="info"
        gutterBottom
        sx={{ fontWeight: "bold", textAlign: "center", mb: 4 }}
      >
        Pesupalvelu
      </Typography>

      <Box maxWidth="1200px" mx="auto" pb={6}>
        <Grid container spacing={3}>
          {Object.entries(tableData).map(([category, items], index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
                <CardContent>
                  <Typography component='h1' variant="h6" color="error" sx={{ mb: 2 }}>
                    {category}
                  </Typography>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        {Object.entries(items).map(([item, price], i) => (
                          <TableRow key={i}>
                            <TableCell>{item}</TableCell>
                            <TableCell>{price}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Typography
        variant="h5"
        gutterBottom
        color="info"
        sx={{ fontWeight: "bold", textAlign: "center", mt: 4, mb: 2 }}
      >
        Blogi
      </Typography>

      <Box maxWidth="1200px" mx="auto" pb={6}>
        <Grid container spacing={4} justifyContent="center" sx={{ mb: 6 }}>
          {blogPosts.map((post, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Card
                className="rounded-2xl shadow-lg overflow-hidden"
                sx={{
                  transition: "0.3s",
                  "&:hover": { transform: "scale(1.02)" },
                }}
              >
                <img
                  src={post.image}
                  alt={post.title || "Blogikuva"}
                  style={{ width: "100%", height: 200, objectFit: "cover" }}
                />
                <CardContent>
                  <Typography component='h1' variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                    {post.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray", mb: 2 }}>
                    {post.excerpt.length > 120
                      ? post.excerpt.slice(0, 117) + "..."
                      : post.excerpt}
                  </Typography>
                  <Link to={post.link}>
                    <Button variant="contained" color="primary">
                      Lue lisää
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
